import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CookieEnum } from '../../enums/cookie-enum';
import { useGetMyCompanyQuery } from '../../store/apiSlice/companyApi';
import { Loading } from '../shared/loader/Loader';
import { useSelector } from 'react-redux';
import { selectAuthData } from '../../store/selectors/authSelector';

const SubscriptionPaymentProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const authData = useSelector(selectAuthData);
  const token = Cookies.get(CookieEnum.ACCESS_TOKEN);
  const isCompany = authData?.user?.role === 'COMPANY';

  const { data: companyData, isLoading: isCompanyLoading } =
    useGetMyCompanyQuery(undefined, {
      skip: !isCompany || !token,
    });

  useEffect(() => {
    if (!token && location.pathname !== '/login') {
      navigate('/login');
    }
  }, [location.pathname, navigate, token]);

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!isCompany) {
    return <Navigate to="/" replace />;
  }

  if (isCompanyLoading) {
    return <Loading />;
  }

  if (!companyData) {
    return <Navigate to="/registration/company" replace />;
  }

  return children;
};

export default SubscriptionPaymentProtectedRoute;
